module.exports = __webpack_public_path__ + "static/media/24UHCHR18.3a23757a.jpg";